import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  InputBase,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Stack,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Avatar,
  useTheme,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useRequestState } from "@app/hooks";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { Strings } from "@app/constants";
import { AssignCustomerModal } from "./assign-customer-modal";
import { deleteSalesPerson, salesPerson, salesPersonDetails } from "../slice";
import { selectDeleteSalesPerson, selectSalesPersonState } from "../selector";
import { AddSalespersonModal } from "./add-sales-person-popup";
import { EditPersonPopup } from "./edit-person-popup";

const rowsPerPage = 10;

const SalesPersonPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<number | null>(null);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);

  const { data } = useRequestState({
    stateSelector: selectSalesPersonState,
  });

  useRequestState({
    stateSelector: selectDeleteSalesPerson,
    errorShown: true,
  });

  console.log(selectedRowData, "dattttt--selectrow");

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, id: number) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleChangePage = (_: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const salesPersonList = Array?.isArray(data) ? data : [];

  const filteredData = salesPersonList?.filter((item) => {
    const fullName = `${item?.firstName || ""} ${
      item?.lastName || ""
    }`.toLowerCase();
    return (
      fullName.includes(searchText.toLowerCase()) ||
      item?.email?.toLowerCase().includes(searchText.toLowerCase()) ||
      item?.phone?.toLowerCase().includes(searchText.toLowerCase()) ||
      item?.role?.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const paginatedData = filteredData?.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const handleNavigation = (row: any) => {
    navigate(PATH_DASHBOARD.salesPersonDetails, {
      state: { salesPerson: row },
    });
    dispatch(salesPersonDetails({ id: row?.id }));
  };

  useEffect(() => {
    dispatch(salesPerson({ role: "User" }));
  }, [dispatch]);

  const fontFamily = Strings.fontLanguage.workSans;

  return (
    <Box sx={{ p: 2 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        gap={2}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            borderRadius: 1,
            px: 2,
            py: 1,
            width: "90%",
          }}
        >
          <Icon
            icon="mdi:magnify"
            style={{ marginRight: 8, color: "#757575" }}
          />
          <InputBase
            fullWidth
            placeholder="Search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </Box>
        <Button
          variant="contained"
          startIcon={<Icon icon="mdi:plus" />}
          sx={{
            borderRadius: 1,
            textTransform: "none",
            color: "white",
            backgroundColor: theme.palette.primary.main,
          }}
          onClick={() => setOpenAddModal(true)}
        >
          {Strings.salesPerson.addSalesPerson}
        </Button>
      </Stack>
      <Paper>
        <TableContainer>
          <Table>
            <TableHead sx={{ backgroundColor: "#F4F6F8" }}>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.dashboard.name}
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.salesPerson.contact}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.salesPerson.email}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.salesPerson.role}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.salesPerson.customersAssigned}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.dashboard.action}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData?.length > 0 ? (
                paginatedData?.map((row) => (
                  <TableRow
                    key={row?.id}
                    hover
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleNavigation(row)}
                  >
                    {/* <TableCell align="center">
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                      >
                        <Avatar
                          alt={`${row?.firstName} ${row?.lastName}` || "Avatar"}
                          src={row?.profileImage || ""}
                          sx={{ width: 32, height: 32, fontSize: 14 }}
                        >
                          {!row?.profileImage && row?.firstName
                            ? `${row?.firstName[0]}${
                                row?.lastName?.[0] || ""
                              }`.toUpperCase()
                            : "N"}
                        </Avatar>
                      </Box>
                    </TableCell> */}
                    <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.firstName || "N/A"}
                    </TableCell>
                    {/* <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.lastName || "N/A"}
                    </TableCell> */}
                    <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.phone || "N/A"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.email || "N/A"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.role || "N/A"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.assignedCustomers?.length || 0}
                    </TableCell>
                    <TableCell
                      align="center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <IconButton onClick={(e) => handleMenuOpen(e, row.id)}>
                        <Icon icon="mdi:dots-vertical" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={5}
                    align="center"
                    sx={{
                      py: 6,
                      fontSize: "1rem",
                      color: "text.secondary",
                      mt: 4,
                    }}
                  >
                    {Strings.salesPerson.dataNotFound}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            py: 1,
            borderTop: "1px solid #eee",
            marginLeft: "auto",
          }}
        >
          <Typography variant="body2" sx={{ marginLeft: "auto" }}>
            Showing {(page - 1) * rowsPerPage + 1} to {""}
            {Math.min(page * rowsPerPage, filteredData?.length)} of
            {" " + filteredData?.length} Users
          </Typography>
          <Pagination
            count={Math.ceil(filteredData?.length / rowsPerPage)}
            page={page}
            onChange={handleChangePage}
            color="primary"
            shape="rounded"
            size="small"
            siblingCount={0}
            boundaryCount={1}
            sx={{
              "& .MuiPaginationItem-root": {
                minWidth: 25,
                height: 25,
                fontSize: 14,
              },
              "& .MuiPaginationItem-ellipsis": {
                mx: 1,
              },
              "& .MuiPaginationItem-root.Mui-selected": {
                color: "#fff",
                backgroundColor: "#1976d2",
                borderRadius: "6px",
                fontWeight: 500,
              },
            }}
          />
        </Box>
      </Paper>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem
          onClick={() => {
            handleMenuClose();
            const rowData = paginatedData.find(
              (item) => item.id === selectedRow
            );
            setSelectedRowData(rowData);
            setOpenEditPopup(true);
          }}
        >
          {Strings.button.edit}
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            handleMenuClose();
            if (selectedRow) {
              dispatch(deleteSalesPerson({ salesPersonId: selectedRow }));
            }
          }}
        >
          {Strings.button.delete}
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            handleMenuClose();
            const rowData = paginatedData?.find(
              (item) => item?.id === selectedRow
            );
            setSelectedRowData(rowData);
            setOpenModal(true);
          }}
        >
          {Strings.button.assignCustomer}
        </MenuItem>
      </Menu>
      {openModal && (
        <AssignCustomerModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          selectedSalesPerson={selectedRowData}
        />
      )}
      {openAddModal && (
        <AddSalespersonModal
          open={openAddModal}
          onClose={() => setOpenAddModal(false)}
          role={selectedRowData?.role}
        />
      )}
      {openEditPopup && (
        <EditPersonPopup
          open={openEditPopup}
          onClose={() => setOpenEditPopup(false)}
          selectedRowData={{
            id: selectedRowData.id,
            email: selectedRowData.email,
            firstName: selectedRowData.firstName,
            lastName: selectedRowData.lastName,
            phone: selectedRowData.phone,
            role: selectedRowData.role,
            assignCustomer: selectedRowData.assignCustomer,
            profileImage: selectedRowData.profileImage || null,
          }}
        />
      )}
    </Box>
  );
};
export { SalesPersonPage };
